import {
  CheckIcon,
  EyeClosedIcon,
  FormControlLabel,
  GKButton,
  Grid2,
  LeftIcon,
  LockFillIcon,
  RightIcon,
  Switch,
  Typography,
} from "components";
import { useMemo } from "react";
import { Controller } from "react-hook-form";
import {
  ExtraSectionItemProps,
  FormFooterProps,
  SectionHeaderProps,
  WebsiteSectionCardProps,
} from "./types";

export const WebsiteSectionCard: React.FC<WebsiteSectionCardProps> = ({
  item,
  onClick,
  basketList,
  pmShowOnWebsite,
}) => (
  <Grid2 size={6} key={item.value} sx={{ cursor: "pointer" }} onClick={onClick}>
    <Grid2
      container
      spacing={1}
      border={"1px solid var(--neutral-100)"}
      borderRadius={1}
      p={2}
      position={"relative"}
    >
      {item.value === "MY_BASKETS" && basketList?.length === 0 && (
        <LockFillIcon
          style={{
            position: "absolute",
            right: 10,
            top: "10",
          }}
        />
      )}
      {item.value === "PERFORMANCE_METRICS" && !pmShowOnWebsite && (
        <EyeClosedIcon
          style={{
            position: "absolute",
            right: 10,
            top: "10",
          }}
        />
      )}
      <Grid2 size={12} display={"flex"} justifyContent={"center"}>
        <item.icon color={"var(--neutral-500)"} width={40} height={40} />
      </Grid2>
      <Grid2 size={12} display={"flex"} justifyContent={"center"}>
        <Typography color="var(--grey-900)" fontSize={12} fontWeight={500}>
          {item?.label}
        </Typography>
      </Grid2>
    </Grid2>
  </Grid2>
);

export const ExtraSectionItem: React.FC<ExtraSectionItemProps> = ({
  dataItem,
  isOpen,
  onClick,
}) => (
  <Grid2
    key={dataItem.value}
    size={12}
    display={"flex"}
    justifyContent={"space-between"}
    alignItems={"center"}
    sx={{ cursor: "pointer" }}
    p={"12px 16px"}
    bgcolor={isOpen ? "var(--primary-50)" : undefined}
    borderRadius={"6px"}
    onClick={onClick}
  >
    <Typography fontSize={14} fontWeight={500} color="var(--neutral-700)">
      {dataItem.label}
    </Typography>
    <RightIcon />
  </Grid2>
);

export const SectionHeader: React.FC<SectionHeaderProps> = ({
  selectedSection,
  onBackClick,
  sectionButtons,
}) => {
  const selectedSectionButton = useMemo(() => {
    return sectionButtons.find(
      (dataItem) => dataItem.value === selectedSection,
    );
  }, [sectionButtons, selectedSection]);

  return (
    <Grid2
      size={12}
      p={2}
      borderBottom={
        selectedSection === null ? undefined : "1px solid var(--neutral-100)"
      }
      display={"flex"}
      alignItems={"center"}
    >
      {selectedSection === null ? (
        <Typography fontWeight={700} color="var(--grey-900)">
          Website Sections
        </Typography>
      ) : (
        <Typography
          display={"flex"}
          alignItems={"center"}
          gap={1}
          fontSize={14}
          fontWeight={700}
          color="var(--grey-900)"
          sx={{ cursor: "pointer" }}
          onClick={onBackClick}
        >
          <LeftIcon />
          {selectedSectionButton?.label}
        </Typography>
      )}
    </Grid2>
  );
};

export const FormFooter: React.FC<FormFooterProps> = ({
  selectedSection,
  form,
  loading,
}) => (
  <Grid2
    size={12}
    p={2}
    borderTop={"1px solid var(--neutral-100)"}
    display={"flex"}
    justifyContent={
      selectedSection === "PERFORMANCE_METRICS" ? "space-between" : "flex-end"
    }
  >
    {selectedSection === "PERFORMANCE_METRICS" && (
      <Controller
        name="websiteSection.performanceMetrices.pmShowOnWebsite"
        control={form.control}
        render={({ field }) => {
          return (
            <FormControlLabel
              {...field}
              sx={{ gap: 1 }}
              control={
                <Switch
                  checked={field.value}
                  onChange={(e) => {
                    field.onChange(e.target.checked);
                  }}
                />
              }
              label={
                <Typography fontSize={13} fontWeight={500}>
                  Show this section on website
                </Typography>
              }
              labelPlacement="start"
            />
          );
        }}
      />
    )}

    {!["MY_BASKETS"].includes(selectedSection) && (
      <GKButton
        variant="contained"
        startIcon={<CheckIcon />}
        type="submit"
        form="my-website-form"
        loading={loading}
      >
        Save Changes
      </GKButton>
    )}
  </Grid2>
);
